import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const LiveRoutes: RouteObject = {
	path: "live/*",
	lazy: async () => {
		const { LiveDashboard } = await import(
			"@/components/Live/Pages/LiveDashboard"
		);
		return {
			Component: () => (
				<Sentry.ErrorBoundary
					fallback={({ error, componentStack, resetError }) => (
						<PageError
							error={error}
							componentStack={componentStack}
							reset={resetError}
						/>
					)}
				>
					<LiveDashboard />
				</Sentry.ErrorBoundary>
			),
		};
	},
	children: [
		{
			index: true,
			lazy: async () => {
				const { LiveDashboard } = await import(
					"@/components/Live/Pages/LiveDashboard"
				);
				return { Component: LiveDashboard };
			},
		},
	],
};
